import { ErrorLink } from '@apollo/client/link/error';
import { ERROR_PREFIXES } from 'src/common/constants';
import { DatadogRUMService } from 'src/services/datadog/DatadogRUMService';
import { createDatadogError } from 'src/services/datadog/utils/createDatadogError';

export const logOperationError: ErrorLink.ErrorHandler = ({ graphQLErrors, networkError, operation, response }) => {
    const ErrorClass = createDatadogError(operation.operationName);
    const error = new ErrorClass(`${ERROR_PREFIXES.APOLLO} ${operation.operationName} failed to resolve data`);
    DatadogRUMService.Client.getInstance().addError(error, {
        graphQLErrorsAsString: JSON.stringify(graphQLErrors, null, 2),
        graphQLErrors,
        networkError,
        operation,
        response,
    });
};
